import { render, staticRenderFns } from "./popup-board-options.vue?vue&type=template&id=7ef49a9e&"
import script from "./popup-board-options.vue?vue&type=script&lang=js&"
export * from "./popup-board-options.vue?vue&type=script&lang=js&"
import style0 from "./popup-board-options.vue?vue&type=style&index=0&id=7ef49a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports